import { render } from "./JumbotronNav.vue?vue&type=template&id=36874423&scoped=true"
import script from "./JumbotronNav.vue?vue&type=script&lang=js"
export * from "./JumbotronNav.vue?vue&type=script&lang=js"

import "./JumbotronNav.vue?vue&type=style&index=0&id=36874423&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36874423"]])

export default __exports__